import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { initFilm } from "@/pages/home/lib/film";

const VIDEO_URL = "https://static.readdy.ai/video/f08a7306c533c49e2fe7e7e62d8836d4/ceabb6fcb160e656b4fa76137c4c02e0.mp4";
const POSTER_URL = "https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/f28f1fd567975f6a8c7703a8e509a76e.jpeg";

const CHAPTER_POSTER_ALT =
  "Nurse pulling on blue gloves at the doorway of a home, an older woman waiting in the lit living room behind him";

export default function Chapter() {
  const { t } = useTranslation();
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const host = ref.current?.parentElement || document;
    initFilm(host);
    return () => {
      host.querySelectorAll("video").forEach((v) => {
        v.pause();
        v.removeAttribute("src");
        v.load();
        v.remove();
      });
    };
  }, []);

  return (
    <section
      ref={ref}
      className="chapter"
      data-video={VIDEO_URL}
      data-duration="14"
      data-rate="0.45"
      data-loop-end="0.7143"
      data-poster={POSTER_URL}
      data-label="Facundo Yoldi — enfermería a domicilio"
    >
      <div className="stage">
        <img
          className="plate"
          src={POSTER_URL}
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
          alt={CHAPTER_POSTER_ALT}
        />
        <div className="veil" aria-hidden="true" />
        <div className="veil veil-deep" aria-hidden="true" />
        <div className="veil veil-light" aria-hidden="true" />

        <div
          className="beat"
          data-from="0"
          data-to="0.25"
          data-pos="left"
          data-depth="busy"
          data-tone="dark"
          data-motion="track"
          id="overview"
        >
          <img
            className="hero-logo"
            src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/005364c1e5e38277ee3c064f1a523063.png"
            alt="Facundo Yoldi — Enfermería"
            width={414}
            height={414}
          />
          <p className="stamp">{t("beat1.stamp")}</p>
          <h1 data-split="lines" dangerouslySetInnerHTML={{ __html: t("beat1.h1") }} />
          <h2 className="hero-local">
            <i className="ri-map-pin-2-line" aria-hidden="true" />
            <span>{t("beat1.local")}</span>
          </h2>
          <p className="sub">{t("beat1.sub")}</p>
          <a className="cta" href="#contact">
            {t("beat1.cta")}
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div
          className="beat"
          data-from="0.25"
          data-to="0.52"
          data-pos="left"
          data-depth="soft"
          data-tone="light"
          data-motion="drift"
          id="services"
        >
          <p className="stamp">{t("beat2.stamp")}</p>
          <h2
            data-split="lines"
            dangerouslySetInnerHTML={{ __html: `${t("beat2.h2a")}<br>${t("beat2.h2b")}` }}
          />
          <p className="sub">{t("beat2.sub")}</p>
          <ul className="chips" data-side="right">
            <li>{t("beat2.chip1")}</li>
            <li>{t("beat2.chip2")}</li>
            <li>{t("beat2.chip3")}</li>
          </ul>
        </div>

        <div
          className="beat"
          data-from="0.52"
          data-to="0.74"
          data-pos="center"
          data-depth="soft"
          data-tone="light"
          data-motion="rise"
          id="promise"
        >
          <p className="stamp">{t("beat3.stamp")}</p>
          <h2 data-split="lines" dangerouslySetInnerHTML={{ __html: t("beat3.quote") }} />
        </div>

        <div
          className="beat"
          data-from="0.74"
          data-to="1"
          data-pos="left"
          data-depth="soft"
          data-tone="dark"
          data-motion="zoom"
          id="booking"
        >
          <p className="stamp">{t("beat4.stamp")}</p>
          <h2 data-split="lines" dangerouslySetInnerHTML={{ __html: t("beat4.h2") }} />
          <p className="sub">{t("beat4.sub")}</p>
          <a className="cta" href="#contact">
            {t("beat4.cta")}
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="scroll-cue" aria-hidden="true">
          <span />
        </div>
      </div>
    </section>
  );
}